export default function getIsInIframe() {
  return typeof window !== 'undefined' && window.self !== window.top;
}
